<template>
<!-- eslint-disable max-len -->
<div
  class="choice"
  :style="{
    width: decision.decisionContainerWidthOverride ? decision.decisionContainerWidthOverride : undefined,
    'max-height': decision.decisionContainerMaxHeightOverride ? decision.decisionContainerMaxHeightOverride : undefined,
  }"
>
  <!--
    Never use v-html with end-user generated content, because it's a vector for XSS attacks
  -->
  <h1 v-if="false && !decision.hideTitle && !useArticleLayout"
    class="choice-title"
    style="width: 100%; text-align: center; line-height: 30px; font-size: 26px;"
    v-html="decisionDisplayTitle"
  ></h1>
  <h2
    :style="{
      display: 'flex',
      height: (decision.questionContentHeight ? decision.questionContentHeight : undefined),
      'max-height': ((!(decision.questionContentHeight) && useArticleLayout) ? '330px' : undefined),
      'justify-content': (useArticleLayout ? undefined : 'center'),
      // 'overflow-y': 'auto'
    }"
  >
    <div v-show="decision.image" :style="imageStyle">
      <img
        v-if="!useView360"
        style="width: 100%; height: 100%; object-fit: contain;"
        :style="{
          cursor: (decision.clickToExpandImage ? 'pointer' : undefined),
        }"
        :src="decisionImgSrc"
        @click.prevent="onDecisionImageClicked"
      />
      <View360
        v-else
        class="override-view360"
        auto-resize
        style="width: 100%; height: 100%; object-fit: contain;"
        :style="{
          cursor: (decision.clickToExpandImage ? 'pointer' : undefined),
        }"
        :projection="projection"
        canvas-class="gl-canvas"
        @input-start="onDecisionImageClicked"
      />
      <b-modal
        v-model="imageExpanded"
        modal-class="override-bmodal"
        ok-only
        :size="decision.expandedImageModalWidth || 'lg'"
      >
        <img
          v-if="!useExpandedView360"
          style="width: 100%; object-fit: contain;"
          :style="{
            'max-height': decision.expandedImageMaxHeightOverride || '72vh',
          }"
          :src="expandedDecisionImgSrc"
        />
        <View360
          v-else-if="showModalView360"
          class="override-view360"
          style="width: 100%; object-fit: contain; overflow: hidden;"
          :style="{
            'max-height': `min((100vh - 60px), ${decision.expandedImageMaxHeightOverride || '72vh'})`,
          }"
          auto-resize
          :projection="expandedProjection"
          canvas-class="gl-canvas"
        />
      </b-modal>
      <tooltip
        v-if="decision.image"
        target="videoOrImage"
      >
      </tooltip>
    </div>

    <div
      v-show="decision.video"
      :style="`display: inline; height: fit-content; position: relative;`"
    >
      <video
        :style="`display: inline; max-height: ${
          decision.questionContentHeight
            ? decision.questionContentHeight
            : `${(useArticleLayout
              ? 330
              : ((survey ? 506.25 : 427.5) - (hasPrompt ? 85 : 0)))}px`
        };`"
        :src="resolveAssetPath(decision.video, 'videos')"
        controls
        playsinline
        disablePictureInPicture
        controlslist="nodownload nofullscreen noplaybackrate"
        @play="playToClick"
      ></video>
      <tooltip
        v-if="decision.video"
        target="videoOrImage"
      >
      </tooltip>
    </div>

    <article
      v-if="useArticleLayout"
      class="btn-white choice-description"
      :style="{
        'height': decision.questionContentHeight ? '100%' : '330px',
        'max-width': (decision.image || decision.video) ? undefined : '100%',
        'overflow-y': 'auto',
      }"
    >
      <!--
        Never use v-html with end-user generated content, because it's a vector for XSS attacks
      -->
      <h1 v-if="!decision.hideTitle" class="choice-title" v-html="decisionDisplayTitle"></h1>
      <!--
        Never use v-html with end-user generated content, because it's a vector for XSS attacks,
        but this is okay here since decision.description is only used/set internally.
        AFAIK, this is the simplest way to support hyperlinks, and it also enables any html formatting.
      -->
      <p style="font-size: 24px; margin: 0;" v-html="decisionDisplayDescription"></p>
    </article>
  </h2>
  <div
    v-if="hasPrompt && starfighter"
    :class="`prompt ${(starfighter) ? 'sf' : 'native'}`"
  >
    <!--
      Never use v-html with end-user generated content, because it's a vector for XSS attacks
    -->
    <span v-html="decision.prompt"></span>
  </div>
  <div
    v-if="survey"
    :style="{
      display: 'flex',
      'flex-direction': 'row',
      'justify-content': 'space-between',
      'font-size': '23px',
      color: ((starfighter) ? 'black' : 'white')
    }"
  >
    <div style="margin: 10px 15px;">{{decision.minLabel}}</div>
    <div style="text-align: right; margin: 10px 15px;">{{decision.maxLabel}}</div>
  </div>
  <div style="position: relative;">
    <div
      v-if="decision.type && decision.type === 'multiselect'"
    >
      <div
        style="overflow-y: auto; overflow-x: hidden; padding: 0 0 16px 6px; position: relative;"
        :style="{
          'height': 'fit-content',
          'max-height':
            `calc(${
              (decision.decisionContainerMaxHeightOverride ? `${decision.decisionContainerMaxHeightOverride} - 55px` : '725px')
            } - ${
              (hasPrompt ? 85 : 0)
            }px - ${
              (decision.questionContentHeight ? decision.questionContentHeight : '330px')
            })`,
        }"
      >
        <b-form-checkbox-group
          v-model="choices"
          :options="options"
          stacked
          size="lg"
          class="multiselect-checkboxes"
        ></b-form-checkbox-group>
      </div>
      <button
        v-if="starfighter"
        class="btn"
        style="position: absolute; right: 24px; bottom: 5px; font-size: 180%; height: 50px; padding: 10px; z-index: 100;"
        :disabled="decision.multiselectMinChoices ? (choices.length < decision.multiselectMinChoices) : false"
        @click.prevent="() => { onClickChoice(choices); }"
      >
        <span v-html="submitButtonText ? submitButtonText : 'Select'"></span>
      </button>
    </div>
    <div v-else-if="decision.type && decision.type === 'sliders'">
      <div
        :class="containerClass"
        :style="{
          'height': 'fit-content',
          'max-height':
            `calc(${
              (decision.decisionContainerMaxHeightOverride ? `${decision.decisionContainerMaxHeightOverride} - 55px` : '725px')
            } - ${
              (hasPrompt ? 85 : 0)
            }px - ${
              (decision.questionContentHeight ? decision.questionContentHeight : '330px')
            })`,
        }"
      >
        <template v-if="displayChoices.length > 1">
          <div
            v-for="(choice, idx) in displayChoices"
            :key="`choice-${idx}`"
            :class="`multi-slider-container ${buttonClass}`"
            :style="{
              height: 'fit-content',
              padding: '7px 15px',
              // choice image and showTitle aren't enabled settings for sliders; if that changes, uncomment and test
              // position: (choiceImage(choice) && choice.showTitle) ? 'relative' : undefined,
              // overflow: (choiceImage(choice) && choice.showTitle) ? 'visible' : undefined,
              // 'margin-bottom': (choiceImage(choice) && choice.showTitle) ? '50px' : undefined,
            }"
          >
            <choice-slider
              ref="choiceSlider"
              :choice="choice"
              :idx="idx"
              :decision="decision"
              :background-color="native ? 'white' : 'black'"
              width="100%"
              title-height="fit-content"

              :clock="choice.sliderIsTime"
              :slider-interval="choice.sliderInterval"
              :slider-min="choice.sliderMin"
              :slider-max="choice.sliderMax"
              :color="choice.sliderColor"
              :title="choiceTitle(choice)"
              :display-intervals="choice.sliderDisplayIntervals"
              :no-thumb-or-fill="(slidersBlank && slidersBlank.length > idx) ? slidersBlank[idx] : false"

              @click="() => onSliderInput(idx)"
            />
          </div>
        </template>
        <template v-else>
          <div
            v-for="(choice, idx) in displayChoices"
            :key="`choice-${idx}`"
            class="single-slider-container"
          >
            <choice-slider
              ref="choiceSlider"
              :choice="choice"
              :idx="idx"
              :decision="decision"
              single
              width="950px"
              title-height="fit-content"

              :background-color="native ? 'white' : 'black'"
              :clock="choice.sliderIsTime"
              :slider-interval="choice.sliderInterval"
              :slider-min="choice.sliderMin"
              :slider-max="choice.sliderMax"
              :color="choice.sliderColor"
              :title="choiceTitle(choice)"
              :display-intervals="choice.sliderDisplayIntervals"
              :no-thumb-or-fill="(slidersBlank && slidersBlank.length > idx) ? slidersBlank[idx] : false"

              @click="() => onSliderInput(idx)"
            />
          </div>
        </template>
      </div>
      <!-- This div is just here to make additional room for the button since it has absolute positioning -->
      <div style="height: 30px;"/>
      <transition
        enter-active-class="fadeIn"
        leave-active-class="fadeOut"
      >
        <button
          v-if="!slidersBlank || (slidersBlank.length && slidersBlank.every(sb => !sb))"
          class="btn-choice slider-submit-button"
          :style="{
            height: (decision && decision.choiceSelectButtonHeight) ? decision.choiceSelectButtonHeight: undefined,
            width: (decision && decision.choiceSelectButtonWidth) ? decision.choiceSelectButtonWidth: undefined,
            right: (decision && decision.choiceSelectButtonXOffset)
              ? `calc(20px - ${decision.choiceSelectButtonXOffset})`
              : '20px',
            bottom: (decision && decision.choiceSelectButtonYOffset)
              ? `calc(20px + ${decision.choiceSelectButtonYOffset})`
              : '20px',
          }"
          @click.prevent="onSubmitSliders"
        >
          <span v-html="submitButtonText ? submitButtonText : 'Set'"></span>
        </button>
      </transition>
    </div>
    <div v-else-if="decision.type && decision.type === 'scale'">
      <div
        :class="containerClass"
        :style="{
          'height': 'fit-content',
          'max-height':
            `calc(${
              (decision.decisionContainerMaxHeightOverride ? `${decision.decisionContainerMaxHeightOverride} - 85px` : '695px')
            } - ${
              (hasPrompt ? 85 : 0)
            }px - ${
              (decision.questionContentHeight ? decision.questionContentHeight : '330px')
            })`,
        }"
      >
        <!-- category headers -->
        <div
          style="
            width: 98%;
            padding: 6px 1%;
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div
            :style="{
              width: `${choiceColumnWidth}%`,
            }"
          ></div>
          <div
            v-for="(category, c) in decision.categories"
            :key="`cat-header-${c}`"
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              white-space: pre-wrap;
              text-align: center;
              padding: 0 10px;
            "
            :style="{
              width: `${categoryColumnWidth}%`,
            }"
          >
            <div v-html="category.displayName || category.name"></div>
          </div>
        </div>
        <!-- choice rows -->
        <div
          v-for="(choice, idx) in displayChoices"
          :key="`choice-${idx}`"
          style="
            width: 98%;
            padding: 3px 1%;
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: center;
          "
          :style="{
            'background-color': (idx % 2 === 0) ? 'rgba(0,0,0,0.05)' : undefined,
          }"
        >
          <div
            style="
              display: flex;
              justify-content: start;
              align-items: center;
              white-space: pre-wrap;
              text-align: left;
            "
            :style="{
              width: `${choiceColumnWidth}%`,
            }"
          >
            <div v-html="choiceTitle(choice)"></div>
          </div>
          <div
            v-for="(category, c) in decision.categories"
            :key="`cat-radio-${c}`"
            style="
              display: flex;
              justify-content: center;
              align-items: center;
            "
            :style="{
              width: `${categoryColumnWidth}%`,
            }"
          >
            <b-form-radio
              v-if="choices[idx]"
              v-model="choices[idx].category"
              :aria-label="`${choiceTitle(choice)} ${category.name}`"
              :name="`choice-${idx}-radios`"
              :value="category"
              size="lg"
              style="margin-right: -40px; padding: 0;"
              @change="() => onClickScaleRadioButton(idx, category)"
            ></b-form-radio>
          </div>
        </div>
      </div>
      <!-- This div is just here to make additional room for the button since it has absolute positioning -->
      <div style="height: 60px;"/>
      <transition
        enter-active-class="fadeIn"
        leave-active-class="fadeOut"
      >
        <button
          v-if="choices && choices.length && choices.every(c => c.category)"
          class="btn-choice"
          style="position: absolute; right: 20px; bottom: 20px; width: 100px; font-size: 20px; font-weight: 500;"
          @click.prevent="onSubmitScale"
        >
          <span v-html="submitButtonText ? submitButtonText : 'Set'"></span>
        </button>
      </transition>
    </div>
    <div v-else-if="decision.type && decision.type === 'matrix'">
      <div
        :class="containerClass"
        :style="{
          'height': 'fit-content',
          'max-height':
            `calc(${
              (decision.decisionContainerMaxHeightOverride ? `${decision.decisionContainerMaxHeightOverride} - 85px` : '695px')
            } - ${
              (hasPrompt ? 85 : 0)
            }px - ${
              (decision.questionContentHeight ? decision.questionContentHeight : '330px')
            })`,
        }"
      >
        <!-- category headers -->
        <div
          style="
            width: 98%;
            padding: 6px 1%;
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div
            :style="{
              width: `${choiceColumnWidth}%`,
            }"
          ></div>
          <div
            v-for="(category, c) in decision.categories"
            :key="`cat-header-${c}`"
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              white-space: pre-wrap;
              text-align: center;
              padding: 0 10px;
            "
            :style="{
              width: `${categoryColumnWidth}%`,
            }"
          >
            <div v-html="category.displayName || category.name"></div>
          </div>
        </div>
        <!-- choice rows -->
        <div
          v-for="(choice, idx) in displayChoices"
          :key="`choice-${idx}`"
          style="
            width: 98%;
            padding: 3px 1%;
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: center;
          "
          :style="{
            'background-color': (idx % 2 === 0) ? 'rgba(0,0,0,0.05)' : undefined,
          }"
        >
          <div
            style="
              display: flex;
              justify-content: start;
              align-items: center;
              white-space: pre-wrap;
              text-align: left;
            "
            :style="{
              width: `${choiceColumnWidth}%`,
            }"
          >
            <div v-html="choiceTitle(choice)"></div>
          </div>
          <b-form-checkbox-group
            v-if="choices[idx]"
            v-model="choices[idx].categories"
            size="lg"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
            :style="{
              width: `${100 - choiceColumnWidth}%`,
            }"
          >
            <b-form-checkbox
              v-for="(category, c) in decision.categories"
              :key="`cat-checkbox-${c}`"
              :value="category"
              :aria-label="`${choiceTitle(choice)} ${category.name}`"
              class="multiselect-checkboxes"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 0;
                margin: -48px 0 0 48px;
              "
              :style="{
                width: `${categoryCheckboxCellWidth}%`,
              }"
              @change="() => onClickMatrixCheckbox(idx, category)"
            ></b-form-checkbox>
          </b-form-checkbox-group>
        </div>
      </div>
      <!-- This div is just here to make additional room for the button since it has absolute positioning -->
      <div style="height: 60px;"/>
      <transition
        enter-active-class="fadeIn"
        leave-active-class="fadeOut"
      >
        <button
          class="btn-choice"
          style="position: absolute; right: 20px; bottom: 20px; width: 100px; font-size: 20px; font-weight: 500;"
          @click.prevent="onSubmitMatrix"
        >
          <span v-html="submitButtonText ? submitButtonText : 'Select'"></span>
        </button>
      </transition>
    </div>
    <div v-else-if="decision.type && decision.type === 'matching'">
      <div
        style="
          display: flex;
        "
        :style="{
          'flex-flow': decision.leftToRight ? 'row-reverse nowrap' : 'column nowrap',
          'justify-content':
            (decision.startingCategory && decision.hideUnselectedCategory)
              ? 'center'
              : 'space-between',
          height:
            `calc(${
              (decision.decisionContainerMaxHeightOverride ? `min(900px, ${decision.decisionContainerMaxHeightOverride}) - 55px` : '725px')
            } - ${
              (hasPrompt ? 85 : 0)
            }px - ${
              (decision.questionContentHeight ? decision.questionContentHeight : '330px')
            })`,
        }"
      >
        <!-- categories -->
        <div
          style="
            display: flex;
            align-items: center;
            overflow: auto;
            /* max-height: calc(50% - 2px); */
            flex: 1;
            flex-grow: 1;
          "
          :style="{
            'flex-direction': (decision.categoriesAsRows ? 'column' : 'row'),
            'flex-wrap': ((decision.categoriesWrapLimit > 1) ? 'wrap' : 'nowrap'),
            'justify-content': categoriesOverflow ? 'flex-start' : 'space-around',
            height: decision.leftToRight ? undefined : (decision.categoriesAreaHeight || undefined),
            width: decision.leftToRight ? (decision.categoriesAreaHeight || undefined) : undefined,
            'max-width':
              (decision.leftToRight && decision.startingCategory && decision.hideUnselectedCategory)
                ? (decision.categoriesAreaHeight || undefined)
                : undefined,
            'margin-bottom': decision.leftToRight ? undefined : '4px',
            'margin-left': decision.leftToRight ? '4px' : undefined,
          }"
        >
          <div
            v-for="(category, c) in decision.categories"
            :key="`cat-${c}`"
            style="
              margin: 0 8px 8px 0;
              flex-shrink: 0;
            "
            :style="{
              width: categoryWidth,
            }"
          >
            <!-- Never use v-html with end-user generated content, because it's a vector for XSS attacks -->
            <div
              v-html="category.displayName || category.name || ''"
              style="
                font-size: 21px;
              "
            ></div>
            <div
              style="
                display: flex;
                flex-flow: row nowrap;
                width: 100%;
                overflow: hidden;
              "
            >
              <draggable
                class="cat-drag"
                :style="catDragStyle"
                :list="matchingState[c]"
                group="choices"
                ghost-class="cat-drag-ghost"
                ref="catDrags"
              >
                <div
                  v-for="(choice, i) in matchingState[c]"
                  :key="`cat-${c}-choice-${i}`"
                  class="cat-drag-item btn-choice"
                  :class="buttonClass"
                  role="button"
                  tabindex="0"
                  style="font-size: 13px;"
                  :style="{
                    height: choiceHeight,
                    'line-height': nonDefaultChoiceHeight ? '1.15' : undefined,
                    position: (choiceImage(choice) && choice.showTitle) ? 'relative' : undefined,
                    overflow:
                      (decision.categoryChoicesShowOrderNumber || (choiceImage(choice) && choice.showTitle))
                        ? 'visible'
                        : undefined,
                    'margin-bottom': (choiceImage(choice) && choice.showTitle) ? '50px' : undefined,
                    'margin-right': ((categoriesChoicesWrapLimit > 1) ? '4px' : ''),
                    'margin-left':
                      decision.categoryChoicesShowOrderNumber
                        ? ((categoriesChoicesWrapLimit > 1) ? '54px' : '50px')
                        : ((categoriesChoicesWrapLimit > 1) ? '4px' : ''),
                    width:
                      decision.categoryChoicesShowOrderNumber
                        ? `calc(${categoriesChoiceWidth} - 50px)`
                        : categoriesChoiceWidth,
                    background:
                      (decisionCategoryChoiceColors && decisionCategoryChoiceColors.length > 0)
                        ? decisionCategoryChoiceColors[i % decisionCategoryChoiceColors.length]
                        : undefined,
                  }"
                >
                  <div
                    v-if="decision.categoryChoicesShowOrderNumber"
                    style="
                      position: absolute;
                      right: 100%;
                      top: 0;
                      padding: 0 12px;
                      height: 100%;
                      width: 50px;
                      text-align: center;
                      color: black;
                      font-size: 21px;
                      font-weight: bold;
                      display: flex;
                      flex-flow: row nowrap;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <div>{{i + 1}}</div>
                  </div>
                  <!-- Never use v-html with end-user generated content, because it's a vector for XSS attacks -->
                  <h3
                    v-if="!(choiceImage(choice))"
                    v-html="choiceTitle(choice)"
                    :style="`${(!(survey) && decision.displayOneLineChoices) ? '' : 'padding: 3px;'}${nonDefaultChoiceHeight ? ` line-height: 1.2; position: unset;` : ''}`"
                  ></h3>
                  <img
                    v-if="choiceImage(choice)"
                    :src="choiceImage(choice)"
                    style="width: 100%; height: 100%; object-fit: contain;"/>
                  <!-- Never use v-html with end-user generated content, because it's a vector for XSS attacks -->
                  <h3
                    v-if="choiceImage(choice) && choice.showTitle"
                    v-html="choiceTitle(choice)"
                    :style="`position: absolute; top: calc(100% + 6px); line-height: 130%; width: 100%; color: ${(starfighter) ? 'black' : 'white'};`"
                  ></h3>
                </div>
              </draggable>
              <img
                v-if="decision.categoryDragPromptImage"
                :src="resolveAssetPath(decision.categoryDragPromptImage, 'images')"
                style="
                  margin: auto -8px;
                  max-width: 75px;
                  max-height: 100%;
                  object-fit: contain;
                "
              />
            </div>
          </div>
        </div>
        <!-- choices -->
        <div
          v-if="!(decision.hideUnselectedCategory && decision.startingCategory)"
          style="
            margin-top: 5px;
            overflow: auto;
            /* max-height: calc(50% - 2px); */
            flex: 1;
          "
          :style="{
            'min-height': decision.leftToRight ? undefined : (decision.choicesAreaHeight || '110px'),
            height: decision.leftToRight ? undefined : (decision.choicesAreaHeight || undefined),
            'min-width': decision.leftToRight ? (decision.choicesAreaHeight || '110px') : undefined,
            width: decision.leftToRight ? (decision.choicesAreaHeight || undefined) : undefined,
          }"
        >
          <draggable
            class="cat-drag"
            style="
              min-height: 100%;
            "
            :list="unmatchingState"
            group="choices"
            ghost-class="cat-drag-ghost"
          >
            <div
              v-for="(choice, i) in unmatchingState"
              :key="`nocat-choice-${i}`"
              role="button"
              tabindex="0"
              class="cat-drag-item btn-choice"
              :class="buttonClass"
              style="font-size: 13px;"
              :style="{
                height: choiceHeight,
                'line-height': nonDefaultChoiceHeight ? '1.15' : undefined,
                position: (choiceImage(choice) && choice.showTitle) ? 'relative' : undefined,
                overflow: (choiceImage(choice) && choice.showTitle) ? 'visible' : undefined,
                'margin-bottom': (choiceImage(choice) && choice.showTitle) ? '50px' : undefined,
                'margin-right': ((decision.choicesWrapLimit > 1) ? '4px' : ''),
                'margin-left': ((decision.choicesWrapLimit > 1) ? '4px' : ''),
                width: choiceWidth,
              }"
            >
              <!-- Never use v-html with end-user generated content, because it's a vector for XSS attacks -->
              <h3
                v-if="!(choiceImage(choice))"
                v-html="choiceTitle(choice)"
                :style="`${(!(survey) && decision.displayOneLineChoices) ? '' : 'padding: 3px;'}${nonDefaultChoiceHeight ? ` line-height: 1.2; position: unset;` : ''}`"
              ></h3>
              <img
                v-if="choiceImage(choice)"
                :src="choiceImage(choice)"
                style="width: 100%; height: 100%; object-fit: contain;"/>
              <!-- Never use v-html with end-user generated content, because it's a vector for XSS attacks -->
              <h3
                v-if="choiceImage(choice) && choice.showTitle"
                v-html="choiceTitle(choice)"
                :style="`position: absolute; top: calc(100% + 6px); line-height: 130%; width: 100%; color: ${(starfighter) ? 'black' : 'white'};`"
              ></h3>
            </div>
          </draggable>
          <!-- submit button -->
          <transition
            enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOut"
          >
            <button
              v-if="unmatchingState.length < 1"
              autofocus
              class="btn-choice"
              style="
                position: absolute;
                padding: 1px;
                line-height: 1.13;
                font-size: 30px;
                font-weight: 500;
              "
              :style="{
                height: (decision && decision.choiceSelectButtonHeight) ? decision.choiceSelectButtonHeight: '75px',
                width: (decision && decision.choiceSelectButtonWidth) ? decision.choiceSelectButtonWidth: '160px',
                right: (decision && decision.choiceSelectButtonXOffset)
                  ? `calc(20px - ${decision.choiceSelectButtonXOffset})`
                  : '20px',
                bottom: (decision && decision.choiceSelectButtonYOffset)
                  ? `calc(20px + ${decision.choiceSelectButtonYOffset})`
                  : '20px',
              }"
              @click.prevent="onSubmitMatching"
              ref="matchingSubmitButton"
            >
              <span v-html="submitButtonText ? submitButtonText : 'Submit Matches'"></span>
            </button>
          </transition>
        </div>
        <!-- submit button for when choice area is hidden -->
        <transition
          enter-active-class="animated fadeIn"
          leave-active-class="animated fadeOut"
        >
          <button
            v-if="unmatchingState.length < 1 && decision.hideUnselectedCategory && decision.startingCategory"
            autofocus
            class="btn-choice"
            style="
              position: absolute;
              padding: 1px;
              line-height: 1.13;
              font-size: 30px;
              font-weight: 500;
            "
            :style="{
              height: (decision && decision.choiceSelectButtonHeight) ? decision.choiceSelectButtonHeight: '75px',
              width: (decision && decision.choiceSelectButtonWidth) ? decision.choiceSelectButtonWidth: '160px',
              right: (decision && decision.choiceSelectButtonXOffset)
                ? `calc(20px - ${decision.choiceSelectButtonXOffset})`
                : '20px',
              bottom: (decision && decision.choiceSelectButtonYOffset)
                ? `calc(20px + ${decision.choiceSelectButtonYOffset})`
                : '20px',
            }"
            @click.prevent="onSubmitMatching"
            ref="matchingSubmitButton"
          >
            <span v-html="submitButtonText ? submitButtonText : 'Submit Matches'"></span>
          </button>
        </transition>
      </div>
    </div>
    <div
      v-else-if="choiceDisplayType === 'list'"
      :class="`${containerClass}`"
      :style="{
        'max-height':
          decision.decisionContainerMaxHeightOverride
            ? `calc(${
              (decision.decisionContainerMaxHeightOverride ? `min(900px, ${decision.decisionContainerMaxHeightOverride}) - 55px` : '725px')
            } - ${
              (hasPrompt ? 85 : 0)
            }px - ${
              (decision.questionContentHeight ? decision.questionContentHeight : '330px')
            })`
            : undefined,
      }"
    >
      <button
        :class="`btn-choice ${buttonClass}`"
        :style="`height: ${choiceHeight};${nonDefaultChoiceHeight ? ` line-height: 1.15;` : ''}${choiceWidth ? ` width: ${choiceWidth};` : ''}${(choiceImage(choice) && choice.showTitle) ? ' position: relative; overflow: visible; margin-bottom: 50px;' : ''}${(!dynamicHeightChoices && (choiceHeightOverride && choiceHeightOverride < 32)) ? ` padding: 1px ${15 * (choiceHeightOverride / 32)}px;` : ''}${choiceStartsFocused ? ' margin-top: 16px;' : ''}`"
        v-for="(choice, i) in displayChoices"
        :key="`choice-${i}`"
        @click.prevent="onClickChoice({ choice, selectedChoiceIndex: i })"
        :disabled="choice.disable"
        :tabindex="i + 1"
        v-focus="choice.startsFocused ? true : (!disableAutofocus ? i === 0 : false)"
      >
        <!--
          Never use v-html with end-user generated content, because it's a vector for XSS attacks
          This is what the following line used to be:
          <h3>{{ choice.title }}</h3>
        -->
        <h3
          v-if="!(choiceImage(choice))"
          v-html="choiceTitle(choice)"
          :style="`${(!(survey) && decision.displayOneLineChoices) ? '' : 'padding: 3px;'}${nonDefaultChoiceHeight ? ` line-height: ${(!dynamicHeightChoices && (choiceHeightOverride < 32)) ? '0' : '1.2'}; position: unset;` : ''}`"
        ></h3>
        <p v-if="!(choiceImage(choice)) && !(survey) && showCost && !(choice.hideCost) && !isNaN(parseFloat(choice.displayedCost || choice.cashAdjustment || 0))">
          COST: <span class="currency">{{ -parseFloat((choice.displayedCost != undefined) ? choice.displayedCost : choice.cashAdjustment) || 0 | currency }}</span>
        </p>
        <img
          v-if="choiceImage(choice)"
          :src="choiceImage(choice)"
          style="width: 100%; height: 100%; object-fit: contain;"/>
        <!--
          Never use v-html with end-user generated content, because it's a vector for XSS attacks
        -->
        <h3
          v-if="choiceImage(choice) && choice.showTitle"
          v-html="choiceTitle(choice)"
          :style="`position: absolute; top: calc(100% + 6px); line-height: 130%; width: 100%; color: ${(starfighter) ? 'black' : 'white'};`"
        ></h3>
      </button>
    </div>
    <div
      v-else
      :class="`${containerClass}`"
      :style="{
        color: (starfighter) ? 'black' : 'white',
        'overflow': 'visible',
        'transition': 'height 1s ease-in-out'
      }"
    > <!-- TODO: above css height transition doesn't seem to be working. get it working later. -->
      <div
        v-if="starfighter && !(hasPrompt)"
        :style="{
          width: '100%',
          height: '3px',
          'background-color': 'var(--secondaryColorTransparent)',
          margin: '7px 0'
        }"
      ></div>
      <div style="overflow-x: hidden;">
        <transition
          :enter-active-class="enterActiveClass"
          :leave-active-class="leaveActiveClass"
        >
          <div v-if="showCurrentChoice" style="width: 100%;">
            <div v-if="!(decision.hideChoiceHeader)" style="width: 100%;">
              <!--
                Never use v-html with end-user generated content, because it's a vector for XSS attacks
              -->
              <h3
                v-if="!(choiceImage(currentChoice))"
                v-html="choiceTitle(currentChoice)"
                style="width: 100%; text-align: center;"
              ></h3>
              <p
                v-if="!(choiceImage(currentChoice)) && !(survey) && showCost && !(currentChoice.hideCost) && !isNaN(parseFloat(currentChoice.displayedCost || currentChoice.cashAdjustment || 0))"
                style="position: absolute; right: 15px; top: 15px;"
              >
                COST: <span class="currency">{{ -parseFloat((currentChoice.displayedCost != undefined) ? currentChoice.displayedCost : currentChoice.cashAdjustment) || 0 | currency }}</span>
              </p>
              <img
                v-if="choiceImage(currentChoice)"
                :src="choiceImage(currentChoice)"
                style="width: 100%; height: 100%; object-fit: contain;"/>
              <!--
                Never use v-html with end-user generated content, because it's a vector for XSS attacks
              -->
              <h3
                v-if="choiceImage(currentChoice) && currentChoice.showTitle"
                v-html="choiceTitle(currentChoice)"
                :style="`position: absolute; top: calc(100% + 5px); width: 100%; color: ${(starfighter) ? 'black' : 'white'};`"
              ></h3>
            </div>
            <h5
              :style="{
                'text-align': 'center',
                'font-size': (decision.hideChoiceHeader ? '16px' : undefined),
              }"
            >
              (Option {{currentChoiceIndex + 1}} of {{displayChoices.length}})
            </h5>
            <!--
              Never use v-html with end-user generated content, because it's a vector for XSS attacks
            -->
            <p
              v-if="currentChoice.description"
              v-html="choiceDescription(currentChoice)"
              style="font-size: 24px; overflow-y: auto; max-height: 158px;"
            >
            </p>
          </div>
        </transition>
      </div>
      <div
        style="width: 100%; padding: 0 8px; display: flex; flex-flow: row nowrap; justify-content: space-between; align-items: center;"
      >
        <button
          class="btn"
          @click.prevent="prevChoice"
          style="padding: 12px; position: relative;"
        >
          <img
            :src="resolveAssetPath('ArrowL_Tall.png', 'ui/customer')"
            :style="{
              height: '27px',
              width: '90%',
              'object-fit': 'fill',
            }"
          />
          <tooltip
            target="choiceCarouselLeftArrow"
          >
          </tooltip>
        </button>
        <button
          class="btn"
          @click.prevent="onClickChoice({ choice: currentChoice, selectedChoiceIndex: currentChoiceIndex })"
          style="font-size: 28px; padding: 20px; position: relative;"
          :disabled="currentChoice.disable"
        >
          <span v-html="submitButtonText ? submitButtonText : 'Approve'"></span>
          <tooltip
            target="choiceCarouselSelect"
          >
          </tooltip>
        </button>
        <button
          class="btn"
          @click.prevent="nextChoice"
          style="padding: 12px; position: relative;"
        >
          <img
            :src="resolveAssetPath('ArrowL_Tall.png', 'ui/customer')"
            :style="{
              height: '27px',
              width: '90%',
              'object-fit': 'fill',
              transform: 'rotateY(180deg)',
            }"
          />
          <tooltip
            target="choiceCarouselRightArrow"
          >
          </tooltip>
        </button>
      </div>
    </div>
    <tooltip
      target="choices"
    >
    </tooltip>
  </div>
</div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import draggable from 'vuedraggable';
import { View360, EquirectProjection, CylindricalProjection } from '@egjs/vue-view360';
import ChoiceSlider from './ChoiceSlider';
import Tooltip from './Tooltip';
import { handleIFrames } from '../../../utils/utils';
import renderMarkdown from '../../../utils/markdown';

export default {
  props: {
    reasonBackClicked: { type: Boolean },
    decision: { type: Object },
    submitButtonText: { type: String },
    showCost: { type: Boolean },
    dynamicHeightChoices: { type: Boolean },
    choiceHeightOverride: { type: Number },
    choiceWidthOverride: { type: Number },
    /** array of indices to indicate a special desired order */
    shuffledChoiceOrder: { type: Array, default: () => [] },
    pastChoices: { type: Array, default: () => [] }
  },
  data() {
    return {
      disableAutofocus: true,
      currentChoiceIndex: 0, // used by carousel display type
      showCurrentChoice: true,
      enterActiveClass: 'animated fadeInRight',
      leaveActiveClass: 'animated fadeOutLeft',
      enableChoiceInputChangeSound: false,
      /** choices assigned to categories, 2D array */
      matchingState: [],
      /** choices not yet assigned to categories, 1D array */
      unmatchingState: [],
      categoriesMinHeight: '',
      slidersBlank: [],
      imageExpanded: false,
      showModalView360: false,
      choices: []
    };
  },
  components: {
    ChoiceSlider,
    Tooltip,
    View360,
    draggable,
  },
  computed: {
    ...mapGetters([
      'activeClass',
      'game',
      'selectedAvatar',
      'interpolateRegex',
      'replacements',
      'starfighter',
      'native'
    ]),
    hasPrompt() {
      return this.decision.prompt &&
        this.decision.prompt.trim &&
        this.decision.prompt.trim().length > 0
      ;
    },
    choiceStartsFocused() {
      return this.decision && this.decision.choices && this.decision.choices.length
        && this.decision.choices.some(c => c.startsFocused);
    },
    decisionDisplayTitle() {
      if (this.decision) {
        return (this.decision.displayTitle
          ? this.decision.displayTitle : this.decision.title)
          .replace(this.interpolateRegex, (__, tag) => this.replacements[tag] || '');
      }
      return '';
    },
    decisionDisplayDescription() {
      if (this.decision && this.decision.description) {
        const displayDescription =
          this.decision.description.replace(this.interpolateRegex, (__, tag) => this.replacements[tag] || '');
        if (this.decision.isDescriptionMarkdown) {
          return renderMarkdown(displayDescription);
        }
        return displayDescription;
      }
      return '';
    },
    decisionCategoryChoiceColors() {
      if (this.decision == null || !(this.decision.categoryChoiceColors)) return [];
      try {
        const result = JSON.parse(this.decision.categoryChoiceColors);
        return result;
      } catch (err) {
        console.error('failed to parse category choice colors');
        console.error(this.decision.categoryChoiceColors);
        console.error(err);
        return [];
      }
    },
    useView360() {
      return this.decision && this.decision.view360;
    },
    view360Cylindrical() {
      return this.decision && this.decision.view360ProjectionType === 'Cylindrical';
    },
    decisionImgSrc() {
      return this.decision ? this.resolveAssetPath(this.decision.image, 'images') : '';
    },
    projection() {
      if (this.useView360) {
        return this.view360Cylindrical
          ? new CylindricalProjection({
            src: this.decisionImgSrc,
          })
          : new EquirectProjection({
            src: this.decisionImgSrc,
          });
      }
      return this.decisionImgSrc;
    },
    expandedDecisionImgSrc() {
      return (this.decision && this.decision.expandedImage)
        ? this.resolveAssetPath(this.decision.expandedImage, 'images')
        : this.decisionImgSrc;
    },
    useExpandedView360() {
      return this.decision
        && ((this.decision.expandedImage && this.decision.expandedView360)
          || (!(this.decision.expandedImage) && this.decision.view360));
    },
    expandedView360Cylindrical() {
      return this.decision && this.decision.expandedView360ProjectionType === 'Cylindrical';
    },
    expandedProjection() {
      if (this.useExpandedView360) {
        if (this.useView360 && !(this.decision && this.decision.expandedImage)) {
          return this.projection;
        }
        return this.expandedView360Cylindrical
          ? new CylindricalProjection({
            src: this.expandedDecisionImgSrc,
          })
          : new EquirectProjection({
            src: this.expandedDecisionImgSrc,
          });
      }
      return this.expandedDecisionImgSrc;
    },
    choiceDisplayType() {
      if (this.decision.type !== 'choice') {
        return 'list';
      }
      if (!(this.decision.preventChoiceDisplayTypeOverride)
        && this.activeClass && this.activeClass.choiceDisplayTypeOverride
        && this.activeClass.choiceDisplayTypeOverride !== 'Do Not Force') {
        switch (this.activeClass.choiceDisplayTypeOverride) {
          case 'List': return 'list';
          case 'Carousel': return 'carousel';
          default: return 'list';
        }
      }
      if (!(this.decision.choiceDisplayType)) return 'list';
      return this.decision.choiceDisplayType;
    },
    currentChoice() {
      return this.displayChoices[this.currentChoiceIndex];
    },
    useArticleLayout() {
      return !(this.decision.image || this.decision.video)
        || this.decision.description
        || (this.decisionDisplayTitle && this.decisionDisplayTitle.length > 60);
    },
    imageStyle() {
      if (!this.useArticleLayout) {
        return {
          margin: 'auto',
          'max-width': '100%',
          'max-height': (this.survey) ? '400px' : undefined,
          position: 'relative',
        };
      }
      return {};
    },
    shuffledChoices() {
      if (this.shuffledChoiceOrder && this.shuffledChoiceOrder.length
        && this.shuffledChoiceOrder.length === this.decision.choices.length) {
        return this.decision.choices.map(
          (ch, index) => this.decision.choices[this.shuffledChoiceOrder[index]]
        );
      }
      return this.shuffle(this.decision.choices);
    },
    displayChoices() {
      if (this.decision.forceAlphabeticalChoiceOrder) {
        return this.decision.choices.slice().sort((a, b) => {
          const aTitle = this.choiceTitle(a).toLowerCase();
          const bTitle = this.choiceTitle(b).toLowerCase();
          if (aTitle < bTitle) return -1;
          if (aTitle > bTitle) return 1;
          return 0;
        });
      }

      if (this.decision.forceRandomChoiceOrder
        || (!(this.decision.preventRandomChoiceOrder)
          && (!(this.survey || this.scale || this.decision.feedback) // these default to prevent random choice order
            && this.activeClass && this.activeClass.randomChoiceOrder))) {
        return this.shuffledChoices;
      }
      // if (this.decision.type === 'sliders') {
      //   const res = [];
      //   res.push(this.decision.choices[0]);
      //   return res;
      // }
      return this.decision.choices;
    },
    options() {
      // eslint-disable-next-line arrow-body-style
      return this.displayChoices.map((choice) => {
        return {
          html: `${this.choiceTitle(choice)}`,
          disabled: (this.decision.multiselectMaxChoices
            ? (!(this.choices.includes(choice)) && this.choices.length === this.decision.multiselectMaxChoices)
            : false),
          value: choice
        };
      });
    },
    containerClass() {
      if (this.survey) {
        return 'choice-container-survey';
      }
      if (this.choiceDisplayType === 'list') {
        if (this.decision.choices.some(c => c.image)) {
          return 'choice-container-image';
        }
        if (!(this.decision.displayOneLineChoices)) {
          return 'choice-container-flex';
        }
      }
      return 'choice-container';
    },
    buttonClass() {
      if (this.survey) {
        return 'choice-form-survey';
      }
      if (this.choiceDisplayType === 'list') {
        if (this.decision.choices.some(c => c.image)) {
          return 'choice-form-image';
        }
        if (!(this.decision.displayOneLineChoices)) {
          return 'choice-form-flex';
        }
      }
      return 'choice-form';
    },
    /** only set if a non-default height is being used (e.g. Dynamic Choice Height or Choice Height Override) */
    nonDefaultChoiceHeight() {
      if (this.dynamicHeightChoices) {
        return 'fit-content';
      } else if (this.choiceHeightOverride) {
        return `${this.choiceHeightOverride}px`;
      }
      return undefined;
    },
    choiceHeight() {
      if (this.nonDefaultChoiceHeight) {
        return this.nonDefaultChoiceHeight;
      }
      if (this.decision.choices.some(c => c.image)) {
        return '260px';
      }
      if (this.survey) {
        return '70px';
      }
      if (this.decision.displayOneLineChoices) {
        switch (this.decision.choices.length) {
          case 0: return '0';
          case 1: return '90px';
          case 2: return '90px';
          case 3: return '90px';
          case 4: return '70px';
          default: return '70px';
        }
      }
      return '150px';
    },
    choiceWidth() {
      if (this.choiceWidthOverride) {
        return `${this.choiceWidthOverride}px`;
      } else if (this.survey && this.decision.equalSizedChoices) {
        return `calc(${Math.floor(100 / this.displayChoices.length)}% - 10px)`;
      } else if (this.matching) {
        if (this.decision.choicesWrapLimit && this.decision.choicesWrapLimit >= 1) {
          return `calc(${Math.floor(100 / this.decision.choicesWrapLimit)}% - 8px)`;
        }
        return '100%';
      }
      return undefined;
    },
    choiceColumnWidth() { // for scale decisions and matrix decisions
      return this.decision.choiceColumnWidthPercent
        ? this.decision.choiceColumnWidthPercent
        : (Math.round(10000 / (this.decision.categories.length + 1)) / 100);
    },
    categoryColumnWidth() { // for scale decisions and matrix decisions
      return this.decision.choiceColumnWidthPercent
        ? (Math.round(
          100 * (100 - this.decision.choiceColumnWidthPercent) / this.decision.categories.length
        ) / 100)
        : (Math.round(10000 / (this.decision.categories.length + 1)) / 100);
    },
    categoryCheckboxCellWidth() { // for scale decisions and matrix decisions
      return Math.round(10000 / this.decision.categories.length) / 100;
    },
    categoriesChoiceWidth() {
      if (this.categoriesChoicesWrapLimit && this.categoriesChoicesWrapLimit >= 1) {
        return `calc(${Math.floor(100 / this.categoriesChoicesWrapLimit)}% - 8px)`;
      }
      return '100%';
    },
    categoryWidth() {
      if (this.matching) {
        if (this.decision.categoriesWrapLimit && this.decision.categoriesWrapLimit >= 1) {
          return `calc(${Math.floor(100 / this.decision.categoriesWrapLimit)}% - 8px)`;
        }
        return this.decision.categoriesAsRows ? 'calc(100% - 8px)' : 'calc(33% - 8px)';
      }
      return undefined;
    },
    categoriesChoicesWrapLimit() {
      if (this.decision.categoriesChoicesWrapLimit) {
        return this.decision.categoriesChoicesWrapLimit;
      }
      if (this.decision.categoriesAsRows) {
        return this.decision.choicesWrapLimit;
      }
      if (
        this.decision.categoriesWrapLimit && this.decision.categoriesWrapLimit >= 1
        && this.decision.choicesWrapLimit && this.decision.choicesWrapLimit > 1
      ) {
        return Math.floor(this.decision.choicesWrapLimit / this.decision.categoriesWrapLimit);
      }
      return this.decision.choicesWrapLimit;
    },
    catDragStyle() {
      const style = {};

      style.flex = '1 1 auto';
      style['min-width'] = '0';

      if (this.decision.categoriesAsRows) {
        style.display = 'flex';
        style['flex-flow'] = 'row wrap';
      }

      /*
      if (this.decision.categoryMinHeight) {
        style['min-height'] = this.decision.categoryMinHeight;
      } else if (!(['fit-content'].includes(this.choiceHeight))) { // non-calc-able values won't work
        const maxChoiceRows = this.matchingState.reduce(
          (acc, curr) => Math.max(acc, Math.ceil(curr.length / Math.max(1, this.categoriesChoicesWrapLimit))),
          1,
        );
        style['min-height'] = `calc(8px + ${maxChoiceRows} * (12px + ${this.choiceHeight}))`;
      }
      */
      style['min-height'] = this.categoriesMinHeight;

      return style;
    },
    categoriesOverflow() {
      return this.decision.categories && !(this.decision.categoriesAsRows) && this.decision.categories.length > 3;
    },
    survey() {
      return this.decision.type && this.decision.type === 'survey';
    },
    matching() {
      return this.decision.type && this.decision.type === 'matching';
    },
    scale() {
      return this.decision.type && this.decision.type === 'scale';
    },
  },
  methods: {
    // $emit 'input' { choice, selectedChoiceIndex }
    ...mapActions([
      'playSound',
      'playVoice',
    ]),
    playToClick() {
      window.dispatchEvent(new Event('click'));
    },
    async playChoiceInput() {
      const sound = (this.choiceDisplayType === 'carousel' && !(this.decision.choiceInputChangeSound))
        ? this.game.arrowButtonSound
        : this.decision.choiceInputChangeSound;
      if (this.enableChoiceInputChangeSound && sound) {
        await Vue.nextTick();
        this.playSound({
          sound,
          soundIsUnstoppable: true,
        });
      }
    },
    async playChoiceInputOff() {
      if (this.enableChoiceInputChangeSound && (this.decision.choiceInputOffSound || this.decision.choiceInputChangeSound)) {
        await Vue.nextTick();
        this.playSound({
          sound: (this.decision.choiceInputOffSound || this.decision.choiceInputChangeSound),
          soundIsUnstoppable: true,
        });
      }
    },
    async playClick() {
      await Vue.nextTick();
      this.playSound({
        sound:
          this.decision.choiceSelectButtonSound
          || this.game.clickSoundOverride
          || this.resolveAssetPath('click_cut.mp3', 'ui/customer'),
        soundIsUnstoppable: true,
      });
    },
    onDecisionImageClicked() {
      if (this.decision && this.decision.clickToExpandImage) {
        this.imageExpanded = true;
        this.showModalView360 = false;
        setTimeout(() => {
          this.showModalView360 = true;
        }, 200);
      }
    },
    onSliderInput(index) {
      if (this.slidersBlank && this.slidersBlank.length > index && index >= 0 && this.slidersBlank[index]) {
        this.$set(this.slidersBlank, index, false);
      }
      this.playChoiceInput();
    },
    onClickScaleRadioButton(idx, category) {
      this.playChoiceInput();
      if (this.decision.oneChoicePerCategory) {
        this.choices.forEach((c, cIdx) => {
          if (idx !== cIdx && c.category === category) {
            console.log(`clearing ${category} from choice ${cIdx}`);
            c.category = null;
          }
        });
      }
    },
    onClickMatrixCheckbox(idx, category) {
      if (this.choices[idx].categories.includes(category)) {
        this.playChoiceInput();
      } else {
        this.playChoiceInputOff();
      }
      if (this.decision.oneChoicePerCategory) {
        this.choices.forEach((c, cIdx) => {
          if (idx !== cIdx) {
            c.categories = c.categories.filter(cat => cat !== category);
          }
        });
      }
    },
    async onSubmitSliders() {
      const data = [];

      // eslint-disable-next-line no-restricted-syntax
      for (const slider of this.$refs.choiceSlider) {
        const obj = Object.assign(
          { sliderValue: slider.value, valueString: slider.valueString },
          slider.choice
        );
        data.push(obj);
      }

      this.onClickChoice(data);
    },
    async onSubmitScale() {
      // console.log(this.choices);
      this.onClickChoice(this.choices);
    },
    async onSubmitMatrix() {
      // console.log(this.choices);
      this.onClickChoice(this.choices);
    },
    async onSubmitMatching() {
      const data = [];

      this.matchingState.forEach((cat, index) => {
        const category = this.decision.categories[index];
        cat.forEach((choice) => {
          const copy = Object.assign(
            {},
            choice
          );
          copy.category = {};
          Object.assign(copy.category, category);
          data.push(copy);
        });
      });

      this.onClickChoice(data);
    },
    async onClickChoice(data) {
      this.enableChoiceInputChangeSound = false;
      const d = (data != null) ? data : this.choices;
      await this.playClick();
      await new Promise(resolve => setTimeout(resolve, 250));
      this.$emit('input', d);
    },
    async nextChoice() {
      this.enterActiveClass = 'animated fadeInRight';
      this.leaveActiveClass = 'animated fadeOutLeft';
      await Vue.nextTick();
      this.showCurrentChoice = false; // animate out
      await new Promise(resolve => setTimeout(resolve, 300));
      this.currentChoiceIndex = (this.currentChoiceIndex + 1) % this.displayChoices.length;
      this.showCurrentChoice = true; // animate in
    },
    async prevChoice() {
      this.enterActiveClass = 'animated fadeInLeft';
      this.leaveActiveClass = 'animated fadeOutRight';
      await Vue.nextTick();
      this.showCurrentChoice = false; // animate out
      await new Promise(resolve => setTimeout(resolve, 300));
      this.currentChoiceIndex -= 1;
      if (this.currentChoiceIndex < 0) this.currentChoiceIndex = this.displayChoices.length - 1;
      this.showCurrentChoice = true; // animate in
    },
    shuffle(array) {
      // ***
      // Fisher-Yates JS implementation from: https://stackoverflow.com/a/2450976
      // ***
      let currentIndex = array.length;
      let temporaryValue;
      let randomIndex;
      // While there remain elements to shuffle...
      while (currentIndex !== 0) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }
      return array;
    },
    choiceImage(choice) {
      if (choice.playerVariantImage) {
        const variant =
          this.selectedAvatar.imageVariants.find(v => v.name === choice.playerVariantImage);
        if (variant) {
          return this.resolveAssetPath(variant.image, 'characters');
        }
      }

      if (choice.image) {
        return this.resolveAssetPath(choice.image, 'images');
      }

      return null;
    },
    choiceTitle(choice) {
      return (choice && choice.title)
        ? (choice.title.replace(this.interpolateRegex, (__, tag) => this.replacements[tag] || ''))
        : '';
    },
    choiceDescription(choice) {
      return (choice && choice.description)
        ? (choice.description.replace(this.interpolateRegex, (__, tag) => this.replacements[tag] || ''))
        : '';
    },
    log(evt) {
      console.log(evt);
    },
  },
  watch: {
    async pastChoices(newValue) {
      const old = this.enableChoiceInputChangeSound;
      this.enableChoiceInputChangeSound = false;
      this.choices = [...newValue];
      await this.$nextTick();
      this.enableChoiceInputChangeSound = old;
    },
    choices(newValue, oldValue) {
      if (newValue && oldValue && oldValue.length != null && newValue.length < oldValue.length) {
        this.playChoiceInputOff();
      } else {
        this.playChoiceInput();
      }
    },
    currentChoiceIndex() {
      this.playChoiceInput();
    },
    async matchingState() {
      this.playChoiceInput();
      // console.log(this.$refs.catDrags);
      this.categoriesMinHeight = ''; // needed to let the min shrink when using catDrags to size
      if (this.$refs.catDrags && this.$refs.catDrags.length) {
        await this.$nextTick();
        const maxClientHeight = this.$refs.catDrags.reduce(
          (acc, curr) => Math.max(acc, curr.$el.clientHeight),
          0,
        );
        this.categoriesMinHeight = `${maxClientHeight}px`;
        if (this.decision.categoryMinHeight) {
          this.categoriesMinHeight = `max(${this.categoriesMinHeight}, ${this.decision.categoryMinHeight})`;
        }
      } else if (this.decision.categoryMinHeight) {
        this.categoriesMinHeight = this.decision.categoryMinHeight;
      }

      if (this.unmatchingState && this.unmatchingState.length < 1) {
        await new Promise(resolve => setTimeout(resolve, 500));
        this.$refs.matchingSubmitButton.focus();
      }
    },
  },
  async mounted() {
    this.choices = [...this.pastChoices];
    if (this.decision.type === 'matching') {
      if (this.decision.categories && this.decision.categories.length) {
        this.matchingState = this.decision.categories.map(() => []);
      }
      // restore matchingState/unmatchingState when going back from confirm
      if (this.pastChoices && this.pastChoices.length) {
        this.pastChoices.forEach((choice) => {
          if (
            choice.category && choice.category._id && this.decision.categories && this.decision.categories.length
          ) {
            const catIndex = this.decision.categories.findIndex(({ _id }) => `${_id}` === `${choice.category._id}`);
            if (catIndex >= 0) {
              this.matchingState[catIndex].push(choice);
            }
          } else {
            this.unmatchingState.push(choice);
          }
        });
      } else if (this.decision.startingCategory) { // setup starting category
        const catIndex = this.decision.categories.findIndex(({ _id }) => `${_id}` === `${this.decision.startingCategory}`);
        if (catIndex >= 0) {
          this.matchingState[catIndex].push(...(this.displayChoices));
        } else {
          this.unmatchingState.push(...(this.displayChoices));
        }
      } else { // default setup
        this.unmatchingState.push(...(this.displayChoices));
      }
    } else if (this.decision.type === 'sliders') {
      this.slidersBlank = this.displayChoices.map(c => c.sliderStartBlank);
    } else if (this.decision.type === 'scale') {
      if (!(this.choices) || this.choices.length < this.displayChoices.length) {
        this.choices = this.displayChoices.map(c => Object.assign({}, c));
      }
    } else if (this.decision.type === 'matrix') {
      if (!(this.choices) || this.choices.length < this.displayChoices.length) {
        this.choices = this.displayChoices.map(c => Object.assign({ categories: [] }, c));
      }
    }
    await Vue.nextTick();
    if (this.useArticleLayout && !(this.reasonBackClicked)) { // only play voice lines when first presented with the decision
      let shouldQueue = false;
      if (!(this.decision.hideTitle) && this.decision.titleVoiceLine) {
        shouldQueue = true;
        if (this.decision.descriptionVoiceLine) {
          await Vue.nextTick();
          this.playVoice({ line: this.decision.titleVoiceLine, next: this.decision.descriptionVoiceLine });
        } else {
          await Vue.nextTick();
          this.playVoice({ line: this.decision.titleVoiceLine });
        }
      } else if (this.decision.descriptionVoiceLine) {
        shouldQueue = true;
        await Vue.nextTick();
        this.playVoice({ line: this.decision.descriptionVoiceLine });
      }

      if (this.decision.promptVoiceLine) {
        await Vue.nextTick();
        this.playVoice({ line: this.decision.promptVoiceLine, queue: shouldQueue, });
        shouldQueue = true;
      }

      if (this.decision.choices && this.displayChoices && this.displayChoices.length) {
        // uses displayChoices to match order of choices on screen, which may be shuffled or sorted
        const queueChoiceVoiceLines = async() => {
          // eslint-disable-next-line no-restricted-syntax
          for (const choice of this.displayChoices) {
            await Vue.nextTick();
            this.playVoice({ line: choice.titleVoiceLine, queue: shouldQueue, });
            shouldQueue = true;
          }
        };
        queueChoiceVoiceLines();
      }
    }
    handleIFrames();
    this.enableChoiceInputChangeSound = true;
  }
};
</script>

<style lang="scss" scoped>
/deep/ .multiselect-checkboxes .custom-control-label::after {
  transform: translate(50%, 45%) scale(1.6);
}

/deep/ .multiselect-checkboxes .custom-control-label::before {
  transform: translate(50%, 45%) scale(1.6);
}

/deep/ .multiselect-checkboxes .custom-control-label {
  padding: 0 16px;
  font-size: 160%;
}

.fadeOutRight,
.fadeOutLeft {
  -webkit-animation-duration: 0.5s;
  -moz-animation-duration: 0.5s;
  -o-animation-duration: 0.5s;
  animation-duration: 0.5s;
}

@keyframes bubble-anim {
  0% {
    transform: scale(1, 1);
    border-radius: 2px;
  }

  50% {
    transform: scale(1.005, 1.005);
    border-radius: 12px;
  }

  100% {
    transform: scale(1, 1);
    border-radius: 2px;
  }
}

.prompt {
  // position: absolute;
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  height: 60px;
  background-color: var(--neutralColor);
  color: white;
  text-align: center;
}
.prompt.sf {
  border: 4px solid black;
  font-size: 20px;
}
.prompt.native {
  border: 2px solid white;
  font-size: 25px;
}

.choice {
  position: absolute;
  width: 1225px;
  max-height: 780px;
  background-color: white;
  border-radius: 2px;
  padding: 20px;
  //animation: bubble-anim 3s infinite;
}
.choice h2 {
  margin-bottom: 20px;
}
.choice h2 img {
  min-width: 390px;
  max-width: 390px;
  min-height: 315px;
  max-height: 315px;
  object-fit: contain;
  object-position: top center;
  display: inline-block;
  margin-right: 20px;
  border: 4px;
  border-radius: 2px;
}
.choice .btn-white {
  max-width: 775px;
  height: 100%;
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: center;
  padding: 15px 15px 0;
  background-color: white;
  margin: 0;
}
.choice-description {
  overflow-y: auto;
}
.choice-title {
  line-height: 38px;
  font-size: 34px;
  // font-weight: bold;
  color: var(--primaryColor);
}
.choice h2 article p {
  // line-height: 34px;
  font-size: 24px;
  // font-weight: bold;
  color: black;
}
.choice-container-survey {
  width: 100%;
  max-height: 330px;
  overflow-y: auto;
  overflow-x: visible;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-between;
  padding: 5px 8px;
  position: relative;
}
.choice-container-flex {
  width: 100%;
  max-height: 330px;
  overflow-y: auto;
  overflow-x: visible;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  position: relative;
}
.choice-container-image {
  width: 100%;
  max-height: 330px;
  overflow-y: auto;
  overflow-x: visible;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-around;
  padding-top: 5px;
  position: relative;
}
.choice-container {
  width: 100%;
  max-height: 330px;
  overflow-y: auto;
  overflow-x: visible; // doesn't work with y set to auto
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  position: relative;
}
.choice-form-survey {
  height: 150px;
  margin-left: 10px;
  margin-bottom: 10px;
  position: relative;
  padding: 5px 0 0;
  text-align: left;
  flex-grow: 1;
}
.choice-form-flex {
  width: 570px;
  height: 150px;
  margin-left: 5px;
  margin-right: 5px;
  margin-bottom: 10px;
  position: relative;
  padding: 15px;
  text-align: left;
}
.choice-form-image {
  width: 30%;
  height: 250px;
  // margin-left: 3%;
  margin-bottom: 10px;
  padding: 1px;
  padding-top: 5px;
}
.choice-form {
  width: 98%;
  height: 70px;
  margin-bottom: 9px;
  position: relative;
  padding: 15px;
  text-align: left;
  flex-shrink: 0;
}
article.choice-form {
  display: flex;
  flex-flow: row;
  align-items: center;
}
.choice-form-survey h3 {
  font-size: 38px;
  width: 100%;
  text-align: center;
}
.choice-form-flex h3 {
  position: absolute;
  left: 2.5%;
  top: 5px;
  font-size: 38px;
  width: 95%;
  margin: 0;
}
.choice-form h3 {
  position: absolute;
  left: 20px;
  bottom: 50%;
  font-size: 42px;
  line-height: 0;
  margin: 0;
}
.choice-form-survey p {
  position: absolute;
  right: 2.5%;
  bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 0;
  font-size: 18px;
  width: 95%;
  text-align: right;
}
.choice-form-flex p {
  position: absolute;
  right: 2.5%;
  bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 0;
  font-size: 18px;
  width: 95%;
  text-align: right;
}
.choice-form p {
  position: absolute;
  right: 20px;
  top: 50%;
  line-height: 0;
  font-size: 20px;
  text-align: right;
}
.choice-form-flex p span {
  font-size: 28px;
  // font-weight: bold;
  margin-left: 4px;
}
.choice-form p span {
  font-size: 32px;
  // font-weight: bold;
  line-height: 0;
  margin-left: 4px;
}
.choice-form .btn-choice {
  margin: 0 inherit;
}
.choice-form .btn-btn {
  position: absolute;
  right: 10px;
  top: 5px;
  width: 140px;
  height: 70px;
  font-size: 28px;
  line-height: 30px;
  white-space: normal;
  padding-top: 2px;
}

/* Sliders */
.single-slider-container
{
  display: flex;
  justify-content: space-around;
  min-height: 200px;
  width: 100%;
}
.slider-submit-button {
  position: absolute;
  width: 100px;
  font-size: 20px;
  font-weight: 500;
}

/* matching */
.cat-drag {
  border: 1px solid grey;
  border-radius: 8px;
  padding: 8px 8px 1px;
  min-height: 110px;
  background-color: rgba(128, 128, 128, 0.25);
  box-shadow: inset 2px 2px grey;
}

.cat-drag-item {
  cursor: move; /* fallback if grab cursor is unsupported */
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
  // should drag-item height always be dynamic height mode?
  // height: fit-content !important;
}

.cat-drag-item:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}

.cat-drag-ghost {
  content: '' !important;
  filter: none !important;
  background: none !important;
  box-shadow: none !important;
  padding: 0 !important;
  min-height: 1px !important;
  min-width: 1px !important;
  height: 16px !important;
  width: 16px !important;
  border: 2px dashed grey !important;
  // display: none;
}
// maybe use different ghost class for row- vs column- flowing draggables

/deep/ .override-bmodal > .modal-fullscreen {
  width: 95vw !important;
  max-width: unset !important;
  height: fit-content !important;
  max-height: calc(100vh - 60px) !important;
}

/deep/ .override-view360 > .gl-canvas {
  width: 100% !important;
  height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/Choice.vue